import { weenatIntl } from '@weenat/wintl';
import isArray from 'lodash-es/isArray';
import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import { useClient } from '../ClientProvider';
import { NotificationChannel, NotificationPreferenceType } from '../resources/me';
import useQuery from '../useQuery';
/**
 * The labels are explicitly hardcoded so that they are not translated
 */
export const languageOptions = [
    {
        value: 'fr',
        label: 'Français'
    },
    {
        value: 'en',
        label: 'English'
    },
    {
        value: 'es',
        label: 'Español'
    },
    {
        value: 'de',
        label: 'Deutsch'
    },
    {
        value: 'it',
        label: 'Italiano'
    },
    {
        value: 'pl',
        label: 'Polski'
    },
    {
        value: 'pt',
        label: 'Português'
    }
];
const useMyInfo = (opts) => {
    const client = useClient();
    const getMyInfoRequest = useQuery(client.me.getMyInfo(), {
        enabled: isNil(opts?.isEnabled) ? true : opts?.isEnabled
    });
    return { data: getMyInfoRequest.data, request: getMyInfoRequest };
};
/** Whether or not the current user is a paid user */
export const useHasAtLeastOneBilledOrg = (opts) => {
    const { data: myInfo, request: myInfoRequest } = useMyInfo(opts);
    const subscriptionsTotal = (myInfo?.subscriptions.expert || 0) + (myInfo?.subscriptions.plus || 0);
    return {
        isLoading: myInfoRequest.isLoading,
        hasAtLeastOneBilledOrg: subscriptionsTotal > 0
    };
};
/** Whether or not the current user is a weenat expert user */
export const useIsMemberOfExpertOrg = (opts) => {
    const { data: myInfo, request: myInfoRequest } = useMyInfo(opts);
    const expertSubscriptions = myInfo?.subscriptions.expert || 0;
    return {
        myInfoRequest,
        isMemberOfExpertOrg: expertSubscriptions > 0
    };
};
export const getMessagePerNotificationChannel = (channel) => {
    let key;
    switch (channel) {
        case NotificationChannel.Mail:
            key = weenatIntl.t('models.notificationPreference.channels.email', { capitalize: true });
            break;
        case NotificationChannel.SMS:
            key = weenatIntl.t('models.notificationPreference.channels.sms', { capitalize: true });
            break;
        case NotificationChannel.Push:
            key = weenatIntl.t('models.notificationPreference.channels.push_notifications', {
                capitalize: true
            });
            break;
    }
    return key;
};
const BASE_PATH_TO_CATEGORIES = 'models.notificationPreference.categories';
export const getMessagesPerNotificationPreferenceType = (type) => {
    let typeKey = undefined;
    switch (type) {
        case NotificationPreferenceType.Device:
            typeKey = 'device';
            break;
        case NotificationPreferenceType.Measure:
            typeKey = 'measure';
            break;
        case NotificationPreferenceType.OrgAdmin:
            typeKey = 'org_admin';
            break;
    }
    return !isNil(typeKey)
        ? {
            title: weenatIntl.t(`${BASE_PATH_TO_CATEGORIES}.${typeKey}.title`, { capitalize: true }),
            description: weenatIntl.t(`${BASE_PATH_TO_CATEGORIES}.${typeKey}.description`, {
                capitalize: true
            }),
            activate: weenatIntl.t(`${BASE_PATH_TO_CATEGORIES}.${typeKey}.activate`, {
                capitalize: true
            }),
            deactivate: weenatIntl.t(`${BASE_PATH_TO_CATEGORIES}.${typeKey}.deactivate`, {
                capitalize: true
            })
        }
        : undefined;
};
export const extractErrorsOnPhoneNumbersUpdate = (e) => {
    let extracted = undefined;
    let errCode;
    // Errors per phone number send
    if (!isNil(e.parsedErrors) && !isEmpty(e.parsedErrors)) {
        const errorsByPhone = e.parsedErrors;
        const nfes = isArray(errorsByPhone)
            ? errorsByPhone.map((ebp) => {
                return !isEmpty(ebp.non_field_errors) && !isNil(ebp.non_field_errors)
                    ? ebp.non_field_errors[0]
                    : undefined;
            })
            : !isNil(errorsByPhone.non_field_errors)
                ? errorsByPhone.non_field_errors
                : [];
        const errors = nfes
            .filter((nfe) => !isNil(nfe))
            .map((nfe) => !isNil(nfe) && !isNil(nfe.code) ? weenatIntl.t(`error_codes.${nfe.code}`) : nfe?.message);
        extracted = errors;
    } // Errors on array of phone validation
    else if (!isNil(e.nonFieldErrors) && !isEmpty(e.nonFieldErrors)) {
        const [err] = e.nonFieldErrors;
        errCode = err.code;
    }
    if (!isNil(errCode)) {
        extracted = weenatIntl.t(`error_codes.${errCode}`);
    }
    else {
        extracted = weenatIntl.t('errors.unknown');
    }
    return extracted;
};
